export default {
    "id": "38678230-43e9-49d0-8095-53cc36a850d1",
    "username": "MASTER",
    "name": "MASTER ADMINISTRADOR",
    "profile": "ADMINISTRATOR",
    "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjM4Njc4MjMwLTQzZTktNDlkMC04MDk1LTUzY2MzNmE4NTBkMSIsInVzZXJuYW1lIjoiTUFTVEVSIiwibmFtZSI6Ik1BU1RFUiBBRE1JTklTVFJBRE9SIiwicHJvZmlsZSI6IkFETUlOSVNUUkFUT1IiLCJpYXQiOjE3MDU4Mzc4OTEsImV4cCI6MTcxODc5Nzg5MX0.qTQO_1sHM_mA7ysy77q3kBJpwRP1FyVncD_Mjx4ukU0"
};